import { z } from "zod/v4";

import { type DatabaseTables } from "../types";
import { type TableSpec, tableSpecSchema } from "./TableSpec";

export type TablesSpec<Tables extends DatabaseTables> = {
	[K in keyof Tables]: TableSpec;
};

export const tablesSpecSchema = z.record(z.string(), tableSpecSchema);

export const isTablesSpec = (value: unknown): value is TablesSpec<DatabaseTables> =>
	tablesSpecSchema.safeParse(value).success;
